/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Qr_Open_CameraInputs */

const vi_qr_open_camera = /** @type {(inputs: Qr_Open_CameraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mở camera quét QR`)
};

/**

* @param {Qr_Open_CameraInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const qr_open_camera = /** @type {((inputs?: Qr_Open_CameraInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qr_Open_CameraInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_qr_open_camera(inputs)
});